module.exports = __webpack_public_path__ + "img/Rose-Petals.1911e778.svg";